import { isDefault } from '../utils/template';

function LoadThemeComponent({ defaultView, baseView }) {
    const isCasino = window.IS_CASINO || new URLSearchParams(window.location.search).get('isCasino') === '1';
    if (isDefault() && !isCasino) {
        return defaultView();
    }
    return baseView();
}

export default LoadThemeComponent;
